export const FETCH_USERFILES = 'FETCH_USERFILES';
export const SET_USERFILES = 'SET_USERFILES';
export const GET_USERFILES_INFO = 'GET_USERFILES_INFO';
export const SET_USERFILES_INFO = 'SET_USERFILES_INFO';
export const ADD_USERFILES = 'ADD_USERFILES';
export const ADD_SUCCESS = 'ADD_SUCCESS';
export const FETCH_SEARCH_USERFILES = 'FETCH_SEARCH_USERFILES';
export const SET_SEARCH_USERFILES = 'SET_SEARCH_USERFILES';
export const FETCH_COUNTER = 'FETCH_COUNTER';
export const SET_COUNTER = 'SET_COUNTER';
export const UPDATE_USERFILES = 'UPDATE_USERFILES';
export const DELETE_USERFILES = 'DELETE_USERFILES';
export const BULK_DELETE_USERFILES = "BULK_DELETE_USERFILES";
